// extracted by mini-css-extract-plugin
export default {"lone-star":"_23sYlOk91VqNhojDaMA","img-div":"swfyEDztKAtxSTmccapT","type-default":"soAVMtv5jAF5T3MqRGAL","common_bganimation":"XhHocjzE9vdolIbOF9nF"};